export class RestriccionConvenio {
    _id_restriccion: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    numero_cliente: String;
    direccion: String;
    id_comuna: String;
    id_region: String;
    archivo_cedula_identidad_propietario: String;
    archivo_cedula_identidad_propietario_reverso: String;
    archivo_titulo_dominio: String;
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    token: String;
    ip: String;
 }